import React, { Component } from "react";
import '../../../../../Assets/EnsembleStyles/EnsNav.css';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import NavbarLogo from '../../../../../Assets/images/green-trane-BA-logo.svg';
import {FaRegBuilding as FaBuilding, FaChartBar as FaChart, FaCog as FaSetting} from 'react-icons/fa';
import { connect } from "react-redux";
import { WorkOrderRolePermission } from '../../../../../action/authenticateUser';
import { getUserDetailsAfterLogin } from '../../../../../action/cultureAction';
import {GetTenantWorkOrderLicenseInfo, ResetError} from '../../../../../action/Administration/administrationAction';
import { Redirect } from 'react-router-dom';
import WorkOrderLogo from '../../../../../Assets/images/icon_.png';

class Navigationheader extends Component {
  componentWillMount() {
    this.props.getUserDetailsAfterLogin();
    this.props.GetTenantWorkOrderLicenseInfo();
    this.props.WorkOrderRolePermission(24);
  }
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.Navigate = this.Navigate.bind(this);
    this.ShowMessage = this.ShowMessage.bind(this);
    this.state = {
      isOpen: false,
      redirect : false,
      routeModules: {
        Preference: false,
        Password: false,
        Logout: false
      }
    };
  }
  Navigate(Index){
    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.routeModules[Index] = true;
    this.setState({redirect:true});
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }
  ShowMessage(){
    if(this.props.ErrorStatus !== undefined && this.props.ErrorStatus !== null && this.props.APIError)
    {
      this.props.ResetError();
    }
  }
  render(store_response, getLabels,getLicenseinfo) {
    let UserName = "";
    let label = this.props.getLabels;
    let license_info = this.props.getLicenseinfo;
    let licensed_features = license_info.licensedFeatures;
    let islicensed = (licensed_features !== undefined) ? licensed_features.length : 0;
    let woicon = (licensed_features !== undefined && islicensed > 0) ? licensed_features[1].licensed: false;
    let tenanticon = (licensed_features !== undefined && islicensed > 0) ? licensed_features[0].licensed : false;
    let dashboardicon = (licensed_features !== undefined && islicensed > 0)? licensed_features[2].licensed : false;
    let aiicon = (licensed_features !== undefined && islicensed > 5) ? licensed_features[5].licensed : false;
    if (this.state.redirect) {
      let routes = this.state.routeModules
      for (let key in routes) {
        if (routes[key]) {
          switch (key) {
            case "reports": return <Redirect to={"/ManageReports/ManageReportsDefinitions"} />;
            case "Preference": return <Redirect to={"/SystemAdmin/GeneralPreferences"} />;
            case "Password": return <Redirect to={"/SystemAdmin/ChangePassword"} />;
            case "Logout": return <Redirect to={"/PropertyMangerLogout"} />;
            default: return <Redirect to={"/PropertyMangerLogout"} />;
          }
        }
      }
    }

    if (this.props.store_response !== undefined && this.props.store_response.user_info !== undefined && this.props.store_response.user_info.firstName !== undefined) {
      var Data = this.props.store_response.user_info;
      UserName = Data.firstName + " " + Data.lastName;
    }

    let lUserCanEdit = this.props.UserCanEdit;
    lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit !== 0 ? true : false;

    return (
      <div className="Navigation_Grid">
        <Navbar className={"Ensemble_Navbackground"} fixed={`top`} light expand="md">
          <NavbarBrand className="Ensemble_mainTitle" >
            <img src={NavbarLogo} alt="Trane Logo" className="Ensemble_trane_logo" />
          </NavbarBrand>

          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
         
            <Nav navbar className="ml-auto" >

            { 
             (dashboardicon === true) ? 
              <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret style={{ "color": "white"}}>
                    <FaChart className="Ensemble_Icon Ensemble_Chart_Icon "/>
                  </DropdownToggle>
                  <DropdownMenu right>
                    <Link to="/Dashboard/ManageDashboard" className="dashboard_nav_link link_cursor drop_down_list" style={{ "color": "black" }} >
                      <DropdownItem className="drop_down_Items_list link_cursor" >
                        {"Dashboard"}
                      </DropdownItem>
                    </Link>
                    <Link to="/ManageReports/ManageReportsDefinitions" className="dashboard_nav_link link_cursor drop_down_list" style={{ "color": "black" }} >
                      <DropdownItem className="drop_down_Items_list link_cursor">
                        {"Reports"}
                      </DropdownItem>
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown> : ""
            }                      
            
              {
                (woicon === true && lUserCanEdit) ?
                  <NavItem className="custom_nav_link">
                    <Link to="/ManageWorkOrder" onClick={this.ShowMessage} className="dashboard_nav_link link_cursor" style={{ "color": "white", 'marginTop': '10px' }} >  
                    {/* <MdBuild className="Ensemble_Icon Ensemble_Building_Icon "/>   */}
                    <img src={WorkOrderLogo} style={{"width":"17px","height":"17px"}} alt="Trane Logo" className="Ensemble_trane_logo" />
                    </Link>
                  </NavItem> : ""
              }
             
              {
                (tenanticon === true) ?
                  <NavItem className="custom_nav_link">
                    <Link to="/managetenant" onClick={this.ShowMessage} className="dashboard_nav_link link_cursor" style={{ "color": "white", 'marginTop': '10px' }} >  <FaBuilding className="Ensemble_Icon Ensemble_Building_Icon " />  </Link>
                  </NavItem> : ""
              }
             
              {
                (aiicon === true) ?
                  <NavItem className="custom_nav_link">
                    <button onClick={(e) => { if(window.showAiChat) window.showAiChat(e); }} className="dashboard_nav_link link_cursor" style={{ "color": "white", 'marginTop': '10px', background: 'none', border: 'none', cursor: 'pointer', padding: '0' }} title="AI Assistant">
                      <svg width="18" height="18" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" className="Ensemble_Icon">
                        <g clipPath="url(#clip0_ai)">
                          <path d="M1.00005 3.99414C1.00005 2.90039 1.87505 1.99414 3.00005 1.99414H15.0001C16.0938 1.99414 17.0001 2.90039 17.0001 3.99414V12.9941C17.0001 14.1191 16.0938 14.9941 15.0001 14.9941H10.6563L6.7813 17.9004C6.62505 18.0254 6.43755 18.0254 6.25005 17.9629C6.0938 17.8691 6.00005 17.7129 6.00005 17.4941V14.9941H3.00005C1.87505 14.9941 1.00005 14.1191 1.00005 12.9941V3.99414ZM6.00005 5.49414C5.43755 5.49414 5.00005 5.96289 5.00005 6.49414V7.99414C5.00005 8.55664 5.43755 8.99414 6.00005 8.99414H7.00005V9.24414C7.00005 9.58789 6.7188 9.90039 6.3438 9.96289L6.12505 10.0254C5.68755 10.0879 5.43755 10.4629 5.50005 10.8691C5.56255 11.2754 5.93755 11.5566 6.3438 11.4941L6.5938 11.4629C7.68755 11.2754 8.50005 10.3379 8.50005 9.24414V7.99414V7.24414V6.49414C8.50005 5.96289 8.0313 5.49414 7.50005 5.49414H6.00005ZM13.0001 7.99414V7.24414V6.49414C13.0001 5.96289 12.5313 5.49414 12.0001 5.49414H10.5001C9.93755 5.49414 9.50005 5.96289 9.50005 6.49414V7.99414C9.50005 8.55664 9.93755 8.99414 10.5001 8.99414H11.5001V9.24414C11.5001 9.58789 11.2188 9.90039 10.8438 9.96289L10.6251 10.0254C10.1876 10.0879 9.93755 10.4629 10.0001 10.8691C10.0626 11.2754 10.4376 11.5566 10.8438 11.4941L11.0938 11.4629C12.1876 11.2754 13.0001 10.3379 13.0001 9.24414V7.99414Z" fill="white" />
                        </g>
                        <defs>
                          <clipPath id="clip0_ai">
                            <rect width="18" height="18" fill="white" transform="translate(0 0.841309)" />
                          </clipPath>
                        </defs>
                      </svg>
                    </button>
                  </NavItem> : ""
              }
             
              <NavItem className="custom_nav_link">
                <Link to="/SystemAdmin/Administration" onClick={this.ShowMessage} className="dashboard_nav_link link_cursor" style={{ "color": "white", 'marginTop': '10px' }} >   <FaSetting className="Ensemble_Icon Ensemble_Building_Icon " /> </Link>
              </NavItem>


              <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret style={{ "color": "white"}}>
                  {UserName}
                </DropdownToggle>
                <DropdownMenu right >
                <DropdownItem className="drop_down_Items_list" onClick={() => { this.Navigate('Preference'); this.ShowMessage(); }}>
                    <Link to="/SystemAdmin/GeneralPreferences" className="dashboard_nav_link link_cursor drop_down_list" style={{ "color": "black" }} >{label !== null ? (label['header.Preferences.Text'] !== undefined ? label['header.Preferences.Text'] : "General Preferences"):"General Preferences"}</Link>
                  </DropdownItem>
                  {/* <DropdownItem  className="drop_down_Items_list" onClick={() => { this.Navigate('Password'); this.ShowMessage(); }}>
                    <Link to="/SystemAdmin/ChangePassword" className="dashboard_nav_link link_cursor drop_down_list" style={{ "color": "black" }} >{label !== null ? (label['header.ChangePassword.Text'] !== undefined ? label['header.ChangePassword.Text'] : "Change Password"):"Change Password"}</Link>
                  </DropdownItem> */}
                  <DropdownItem  className="drop_down_Items_list" onClick={() => { this.Navigate('Logout'); }}>
                    <Link to="/PropertyMangerLogout" className="dashboard_nav_link link_cursor drop_down_list" style={{ "color": "black" }} >{label !== null ? (label['header.Logout.Text'] !== undefined ? label['header.Logout.Text'] : "Logout"):"Logout"}</Link>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>


          

            </Nav>
          </Collapse>
        </Navbar>

      </div>

    );
  }
}


const mapDispatchToProps = dispatch => {
  return {
    getUserDetailsAfterLogin: () => dispatch(getUserDetailsAfterLogin()),
    GetTenantWorkOrderLicenseInfo: () => dispatch(GetTenantWorkOrderLicenseInfo()),
    WorkOrderRolePermission: (applicationId) => dispatch(WorkOrderRolePermission(applicationId)),
    ResetError: () => dispatch(ResetError()),
  };
};

const mapStateToProps = state => {
  return {
    store_response: state.userDetailsRootReducer,
    getLabels: state.CommonResourceDataRootReducer.CommonResourcesData,
    getLicenseinfo: state.InstallationsRootReducer.TenantWorkOrderLicense,
    UserCanEdit: state.authService.HasWorkOrderAccess,
    ErrorStatus: state.authService.ErrorStatus,
    APIError: state.authService.API_not_responding
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Navigationheader);


